import {
  TextInput,
  TextInputReadOnly,
  PhoneNumberInput,
  SelectInput
} from "components/form_new";
import useTranslate from "hooks/use-translate-language";
import { STATES } from "utils/enum";
import selectors from "selectors";
import { propOr } from "ramda";
import { useSelector } from "react-redux";
import { formatDate } from "utils/misc";

const EditInfo = () => {
  const profile = useSelector(selectors.getPatientProfile);

  const translate = useTranslate();
  const patientInfo = propOr({}, "patient_information", profile);
  return (
    <div className="profile-panel">
      <div className="profile-panel-content">
        <TextInput
          label={translate("name")}
          name="patient_information.first_name"
          disabled
        />
        <TextInput
          label={translate("lastName")}
          name="patient_information.last_name"
          disabled
        />
        <TextInput
          label={translate("email")}
          name="patient_information.email"
          disabled
        />
      </div>
      <div className="profile-panel-content">
        <PhoneNumberInput
          label={translate("primaryPhoneNumber")}
          name="patient_information.phone_number"
          type="tel"
        />

        <PhoneNumberInput
          label={translate("secondaryPhoneNumber")}
          name="patient_information.mobile_number"
          type="tel"
        />
      </div>
      <fieldset className="accesibility-fieldset profile-panel-content">
        <TextInput
          label={translate("streetAddress")}
          name="patient_information.home_address.street_address"
        />
        <TextInput
          label={translate("streetAddress2")}
          name="patient_information.home_address.street_address2"
        />

        <TextInput
          label={translate("city")}
          name="patient_information.home_address.city"
        />
        <SelectInput
          label={translate("state")}
          name="patient_information.home_address.state"
          options={STATES}
        />
        <TextInput
          label={translate("zipCode")}
          name="patient_information.home_address.zip"
        />
      </fieldset>
      <fieldset className="accesibility-fieldset profile-panel-content">
        <SelectInput
          label={translate("primaryLanguage")}
          name="patient_information.speaks_spanish"
          options={translate("languageOptions")}
        />
        <TextInputReadOnly
          label={translate("eligibleForSupplies")}
          value={formatDate(patientInfo.insurance_eligibility_date)}
          disabled
        />
      </fieldset>
    </div>
  );
};

export default EditInfo;
